// js
import './kit'
import './menu'
import './slider'
import './rental'
import './homepage'
// css
import '../scss/app.scss'